<div style="margin-right: 32px;" >
  <div class="row">
    <div class="col-md-10">
        <h4 class="title" style="margin-top: 15px;">Table/Field Creation</h4>
    </div>
    <div class="col-md-2">
      <button class="btn btn-primary" (click)="bulk_upload()">Create Fields</button>
      <button class="btn btn-primary" (click)="refresh()">Refresh</button>
    </div>
  </div>
</div>
<br>
<div class="card-box" style="margin: 2px;padding-bottom: 15px;" *ngIf ="booleans">
    <div class="row" style="padding: 0px 0px 23px 10px;">

        <div class="col-md-4">
            <h5 class="form-lable">Choose Bank:</h5>
            <p-dropdown [options]="Bank_list" name='Bank_list_get'  [(ngModel)]="Bank_list_gets" placeholder="Select" optionLabel="y"
                [showClear]="true"></p-dropdown>

        </div>
        <div class="col-md-4">
            <h5 class="form-lable">Choose Product:</h5>
            <p-dropdown [options]="product_list" name='product_list_get' [(ngModel)]="product_list_gets" placeholder="Select" optionLabel="y"
                [showClear]="true"></p-dropdown>
        </div>
        <div class="col-md-4">
            <h5 class="form-lable">Choose Portfolio:</h5>
            <p-dropdown [options]="portfolio_list" name='portfolio_list_get'  [(ngModel)]="portfolio_list_gets" placeholder="Select" optionLabel="y"
                [showClear]="true"></p-dropdown>
        </div>

        <div class="col-md-4">
          <h5 class="form-lable">Actions</h5>
          <button class="btn btn-primary" (click)="fetch_field_list()">Fetch Field Details</button>
      </div>


        <div class="col-md-12">
            <h4 class="title-f" style="margin-top: 15px;">Set Fields</h4>
        </div>
        <div class="col-md-6">
            <h5 class="form-lable">Select Fields:</h5>
            <div>
                <div class="card-box"> <p-table [value]="rows"  styleClass="ui-table-customers" #tt [paginator]="true" [rows]="50"
                    [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [globalFilterFields]="['type']">
                    <ng-template pTemplate="header">
                        <tr style="text-align: center;" class="thhead">
                            <th style="width: 100px;">Action</th>
                            <th style="width: 50px;">S.No</th>
                            <th>Field Name</th>
                            <th>Detailed Field Name</th>
                            <th>Data Type</th>
                            <th>Length</th>
                    </ng-template>
                    <ng-template pTemplate="body" let-item  let-i="rowIndex">
                        <tr class="tdrow">
                            <td class="act">
                              <input type="checkbox" value="{{i}}" *ngIf="!item.check_status" (change)="changeStatus(i,true)">
                              <input type="checkbox"  checked  value="{{i}}" *ngIf="item.check_status" (change)="changeStatus(i,false)">
                                <!-- <p-tableCheckbox [value]="item"></p-tableCheckbox> -->
                            </td>
                            <td style="text-align: center;">{{i+1}}</td>
                            <td>{{item.fields}}</td>
                            <td>{{item.fields_detail}}</td>
                            <td>{{item.data_type}}</td>
                            <td style="text-align: center;">{{item.length}}</td>
                        </tr>
                    </ng-template>
                 </p-table>  </div>
            </div>
            <div>
                <button type="button" class="btn btn-primary" style="margin-top: 10px;" (click)="field_mapping_add()" *ngIf="!submit_button">Ok</button>
                <button type="button" class="btn btn-primary" style="margin-top: 10px;" (click)="field_mapping_edits()" *ngIf="submit_button">Update</button>

            </div>
        </div>
        <div class="col-md-6">
            <h5 class="form-lable">Selected Fields:</h5>
            <div>
                <div class="card-box"> <p-table [value]="selectedProducts" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="50"
                    [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [globalFilterFields]="['type']">
                    <ng-template pTemplate="header">
                        <tr style="text-align: center;" class="thhead">
                            <th style="width: 100px;">Action</th>
                            <th style="width: 50px;">S.No</th>
                            <th>Field Name</th>
                            <th>Detailed Field Name</th>
                            <th>Data Type</th>
                            <th style="text-align: center;">Length</th>
                    </ng-template>
                    <ng-template pTemplate="body" let-item let-i="rowIndex">
                        <tr class="tdrow">
                            <td class="act" style="text-align: center;">
                                <i style="color: #fd2c3a;" class="fa fa-times" aria-hidden="true" pTooltip="Remove" (click)="removeSelected(item,i)"></i>
                            </td>
                            <td style="text-align: center;">{{i+1}}</td>
                            <td>{{item.fields}}</td>
                            <td>{{item.fields_detail}}</td>
                            <td>{{item.data_type}}</td>
                            <td style="text-align: center;">{{item.length}}</td>
                        </tr>
                    </ng-template>
                 </p-table>  </div>
            </div>

        </div>
        <div class="col-md-12" style="margin-top: 20px;">
            <button type="button" class="btn btn-primary" style="float: right;">Save</button>
        </div>
        <!-- <div class="col-md-12 mt-20">
            <button type="button" class="btn btn-primary" (click)="entry()">Bulk Entry</button>
            <button type="button" class="btn btn-primary">Single Entry</button>
        </div> -->
        <div class="col-md-12 mt-20">
            <h4 class="title-f">Process Based Fields:</h4>
            <table class="spec-table">
                <thead>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone No</th>
                    <th>WhatsApp No</th>
                    <th>Landline</th>
                    <th>Extension</th>
                    <th>Staff no</th>
                    <th>Internal ID card no</th>
                    <th>Designation</th>
                    <th>Reporting to</th>
                </thead>
                <tbody>
                    <!-- <tr *ngFor="let arr of contactarray ; let i= index;">
                        <td>{{i+1}}</td>
                        <td>{{arr.con_name}}</td>
                        <td>{{arr.con_role}}</td>
                        <td>{{arr.con_pone}}</td>
                        <td><i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"
                                (click)="remove_contact(i)"></i></td>
                    </tr> -->
                </tbody>
            </table>
        </div>
    </div>
</div>

<p-dialog header="Allocation Excel" [(visible)]="displayPosition2" position="center" [modal]="true"
    [style]="{width: '90%'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div class="row" style="margin-left: 0px;margin-right: 0px;">
      <app-agency-field-add></app-agency-field-add>
    </div>
</p-dialog>
